export default __webpack_public_path__ + "static/media/dia12.841a7cd6.png";